import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'Actions';
import MediaBreakpoints from 'Utils/MediaBreakpoints';
import StandardTextField from 'Utils/redux_form_inputs/StandardTextField';
import StandardSelectField from 'Utils/redux_form_inputs/StandardSelectField';
import {
  combineDateAndTime,
  debounce,
  compareObjects,
} from 'HelperFunctions/general';
import {
  setFilterParams,
  filterFromPropsAndState,
  filterObjToArray,
} from 'HelperFunctions/urls';
import CategoryFilterDesktop from './CategoryFilterDesktop';
import CategoryFilterMobile from './CategoryFilterMobile';
import AvailableItemList from './AvailableItemList';
import BusinessNoItemsPage from './BusinessNoItemsPage';
import Suggestions from 'Utils/Suggestions';
import axios from 'axios';
import LoadingSpinner from 'Utils/LoadingSpinner';
import classnames from 'classnames';
import PageMetaData from 'Utils/PageMetaData';
import EventHeader from './EventHeader';

class SearchCategoryItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      filter: props.filter,
      currentCategory: null,
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.performSearch = debounce(this.performSearch, 500);

    this.handleQueryChange = debounce(this.handleQueryChange, 1000);
    this.handleQuantityChange = debounce(this.handleQuantityChange, 1000);
  }

  componentDidMount() {
    const { filter, fetchSfCategories, fetchInventoryColors } = this.props;

    fetchSfCategories(filter.query);
    fetchInventoryColors(filter.query);
  }

  componentDidUpdate(prevProps, prevState) {
    let filter = this.props.filter;
    const diffs = compareObjects(filter, prevProps.filter);
    const changed = Object.keys(diffs).length > 0;

    // if categories have loaded, set the current one by comparing
    //  the slug in the url against them
    if (prevProps.sfCategories !== this.props.sfCategories) {
      this.setCurrentCategory(this.props.sfCategories);
    }

    // if current category has been set, reload the inventory filtering
    //  by that category
    if (prevState.currentCategory?.id !== this.state.currentCategory?.id) {
      const categories = [this.state.currentCategory.id];
      filter = {
        ...filter,
        selectedNestedSfCategories: categories,
      };
    }

    if (changed) {
      const { reloadInventory, fetchSfCategories, fetchInventoryColors } =
        this.props;
      const filterToSubmit = Object.assign(filter);
      reloadInventory(filterToSubmit);
      fetchSfCategories(filterToSubmit.query);
      fetchInventoryColors(filterToSubmit.query);
    }
  }

  setCurrentCategory = (sfCategories) => {
    const path = window.location.pathname.split('/').slice(2);
    const currentCategory = sfCategories.find(
      (sfCategory) => sfCategory.path === `/${path.join('/')}`
    );
    this.setState({ currentCategory: currentCategory });
  };

  clearColorSelection = () => {
    const { location, history } = this.props;
    setFilterParams(
      {
        selectedColors: null,
        page: null,
      },
      location,
      history
    );
  };

  handleQuantitySelection = (newValues) => {
    const [minQuantity, maxQuantity] = newValues;
    this.setState({
      filter: {
        ...this.state.filter,
        minQuantity,
        maxQuantity,
      },
    });
    this.handleQuantityChange(newValues);
  };

  handleQuantityChange(newValues) {
    const [minQuantity, maxQuantity] = newValues;
    const { location, history } = this.props;
    setFilterParams(
      {
        minQuantity,
        maxQuantity,
        page: null,
      },
      location,
      history
    );
  }

  handleQueryChange(value) {
    const { location, history } = this.props;
    setFilterParams(
      {
        query: value,
        page: null,
      },
      location,
      history
    );
  }

  performSearch = (value) => {
    // this.getResults(value);
  };

  getResults = (query) => {
    const { clientLocation } = this.props;
    axios
      .get(
        process.env.REACT_APP_API_DOMAIN +
          `/api/portal/inventories/search_filter?query=${query}&location_id=${clientLocation.id}`
      )
      .then(({ data }) => {
        this.setState({
          results: data.products,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSearch = (event) => {
    const { value } = event.target;
    this.setState(
      {
        filter: {
          ...this.state.filter,
          query: value,
        },
      },
      this.performSearch(value)
    );
  };

  handleClick = (productType, id) => {
    this.props.history.push(`/shop/${productType}/${id}`);
  };

  handleCategoryClick = (id) => {
    const selected = id;
    this.props.history.push(`/shop?query=&selectedCategories=${selected}`);
    this.setState({
      filter: {
        query: '',
      },
      results: [],
    });
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      const { query } = this.state.filter;
      this.handleQueryChange(query);
    }
  };

  handleNumberPerChange = (event) => {
    const { location, history } = this.props;
    setFilterParams(
      {
        numberPer: event.target.value,
      },
      location,
      history
    );
  };

  notFocused = () => {
    this.setState({
      results: [],
      filter: {
        query: '',
      },
    });
  };

  render() {
    const {
      filter: { selectedSfCategories, selectedColors, numberPer },
      loading,
      loaded,
      inventory,
      storefrontShopSetting,
      event,
    } = this.props;

    const { filter, results, currentCategory } = this.state;
    const allowedFilterList = storefrontShopSetting.allowedFilters?.split(',');

    const noFilter =
      allowedFilterList.length &&
      !allowedFilterList.some((r) =>
        ['date', 'quantity', 'color', 'category'].includes(r)
      );
    const noItems = inventory.length === 0;

    return (
      <div
        className={classnames({
          shop: true,
          noItemsDeprecated: noItems,
        })}
      >
        <PageMetaData setting={storefrontShopSetting} />
        <header>
          <div className='searchFilter'>
            <StandardTextField
              type='search'
              placeholder='Search for Items to Rent...'
              meta={{ error: {} }}
              input={{
                value: filter.query,
                onChange: this.handleSearch,
                onKeyPress: this.handleKeyPress,
                onBlur: this.notFocused,
              }}
            />
            {filter.query !== '' && (
              <Suggestions
                results={results}
                handleClick={this.handleClick}
                handleCategoryClick={this.handleCategoryClick}
              />
            )}
          </div>
          {event && event.editingEvent && <EventHeader />}
        </header>
        {!loaded ? (
          <LoadingSpinner />
        ) : (
          <section
            className={classnames({
              storefront: true,
              noFilter: noFilter,
            })}
          >
            <StandardSelectField
              className='numberSelect'
              meta={{}}
              input={{
                name: 'numberPer',
                value: numberPer,
                onChange: this.handleNumberPerChange,
              }}
            >
              <option value='12'>12</option>
              <option value='24'>24</option>
              <option value='48'>48</option>
            </StandardSelectField>
            <MediaBreakpoints
              desktop={
                <CategoryFilterDesktop
                  history={this.props.history}
                  location={this.props.location}
                  currentCategory={currentCategory}
                  showFilters
                  // Not needed since checkboxes are not used in specific category view
                  handleSfCategorySelected={() => {}}
                  onColorSelection={this.handleColorSelection}
                  onQuantitySelection={this.handleQuantitySelection}
                  selectedColors={selectedColors}
                  selectedMinQuantity={filter.minQuantity || 0}
                  selectedMaxQuantity={filter.maxQuantity || 500}
                  clearColorSelection={this.clearColorSelection}
                  editingEvent={event && event.editingEvent}
                />
              }
              mobile={
                <CategoryFilterMobile
                  currentCategory={currentCategory}
                  showFilters
                  // Not needed since checkboxes are not used in specific category view
                  handleSfCategorySelected={() => {}}
                  onColorSelection={this.handleColorSelection}
                  onQuantitySelection={this.handleQuantitySelection}
                  selectedColors={selectedColors}
                  selectedMinQuantity={filter.minQuantity || 0}
                  selectedMaxQuantity={filter.maxQuantity || 500}
                  clearColorSelection={this.clearColorSelection}
                />
              }
            />
            {loading ? (
              <LoadingSpinner />
            ) : noItems ? (
              <BusinessNoItemsPage />
            ) : (
              <AvailableItemList />
            )}
          </section>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const { sfCategories } = state.categoryList;
  const newFilter = filterFromPropsAndState(ownProps);

  const categoryFromUrl = sfCategories.find(
    (category) => `/${ownProps.match.params?.category}` === category.path
  );
  const selectedNestedSfCategories = categoryFromUrl
    ? [categoryFromUrl.id]
    : filterObjToArray(newFilter.selectedNestedSfCategories);
  const selectedColors = filterObjToArray(newFilter.selectedColors);
  const {
    event,
    event: { eventStart, eventStartTime, eventEnd, eventEndTime },
  } = state.cart;
  const eventStartDateTime = combineDateAndTime(eventStart, eventStartTime);
  const eventEndDateTime = combineDateAndTime(eventEnd, eventEndTime);
  const { inventory, loading, loaded } = state.products;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;

  return {
    filter: {
      ...newFilter,
      selectedColors,
      selectedNestedSfCategories,
      eventStart: eventStartDateTime,
      eventEnd: eventEndDateTime,
    },
    event,
    inventory,
    loading,
    loaded,
    clientLocation: state.locations.location,
    location: ownProps.location,
    storefrontShopSetting,
    sfCategories,
  };
};

export default connect(mapStateToProps, actions)(SearchCategoryItems);
